export const errorMessage = 'Error occured in Container module with locale ';
export const moduleName = 'axp-manage-bookings-container';
export const CONTAINER_MODULE_WRAPPER = 'CONTAINER_MODULE_WRAPPER';
export const ERROR_MSG = `Error occurred while loading ${moduleName} module`;
